import { Component } from '@mycolorway/tao';
import { closest, matches } from 'next/javascripts/modules/dom';
import eventListnerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/slide';

export default Component('tr-slide', {
  mixins: [eventListnerMixin],

  properties: {
    openOnReady: {
      type: Boolean,
      default: true,
    },

    removeAfterClosed: {
      type: Boolean,
      default: false,
    },

    closeOnEscape: {
      type: Boolean,
      default: true,
    },
  },

  ready() {
    const closeBtn = this.querySelector('.slide__close-btn');
    this.listenTo(closeBtn, 'click', () => this.close({ action: 'no' }));

    const modal = this.querySelector('.slide__modal');
    this.listenTo(modal, 'click', () => this.close({ action: 'no' }));

    this.listenTo(document, 'keydown', this.handleKeydown.bind(this));

    if (this.openOnReady) this.open();
  },

  open() {
    if (this.isOpen()) return;

    this.closeAll();
    setTimeout(() => {
      this.listenTo(this, 'transitionend', () => {
        this.namespacedTrigger('opened');
      }, { once: true });

      document.body.classList.add('slide-scroll-lock');
      this.classList.add('slide--open');
      this.namespacedTrigger('beforeOpen');
    });
  },

  close(options = {}) {
    const cancelled = !this.namespacedTrigger('beforeClose', { detail: options });
    if (cancelled) return;

    this.listenTo(this, 'transitionend', () => {
      if (this.removeAfterClosed) this.parentNode.removeChild(this);
      this.namespacedTrigger('closed', { detail: options });
    }, { once: true });

    document.body.classList.remove('slide-scroll-lock');
    this.classList.remove('slide--open');
  },

  isOpen() {
    return this.classList.contains('slide--open');
  },

  setContent(content) {
    this.querySelector('.slide__content').innerHTML = content;
  },

  closeAll() {
    Array.from(document.querySelectorAll('tr-slide'))
      .filter(slide => !slide.isSameNode(this) && slide.taoStatus === 'ready' && slide.isOpen())
      .forEach(slide => slide.close());
  },

  beforeCache() {
    if (this.isOpen()) this.close({ action: 'disconnected' });
  },

  handleKeydown(event) {
    const isEscape = event.key === 'Escape' || event.keyCode === 27;
    if (!isEscape || !this.closeOnEscape) return;

    if (matches(event.target, 'input')
      || matches(event.target, 'textarea')
      || closest(event.target, 'form')
      || closest(event.target, '[contenteditable]')) return;

    if (this.isOpen()) {
      event.stopPropagation();
      event.preventDefault();
      this.close({ action: 'no' });
    }
  },

  disconnected() {
    this.stopListening();
    if (this.isOpen()) this.close({ action: 'disconnected' });
  },
});
